import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fc4aa554&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4aa554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc4aa554')) {
      api.createRecord('fc4aa554', component.options)
    } else {
      api.reload('fc4aa554', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fc4aa554&scoped=true", function () {
      api.rerender('fc4aa554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-template/index.vue"
export default component.exports